import { editUser } from '../../../actions/siteadmin/Users/editUser';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(
        editUser(
            values
        )
    )

}

export default submit;